import { toPersianDigits } from "../../utils/exhibitionUtils";
import LoadingIndicator from "../Atomics/Loading/Loading";

export default function FloorSelector({
  floors,
  currentFloorId,
  onFloorChange,
  onMeetingCardsClick,
  loading,
  showMeetingCards,
  meetingCards,
}) {
  return (
    <div className="exhibition-card" style={{ width: "100%" }}>
      <h2 className="exhibition-title" style={{ fontSize: 18 }}>
        انتخاب سالن
      </h2>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <div className="exhibition-grid exhibition-grid-2">
          {floors
            .filter((f) => {
              const name = f.floor_name || f.floor;
              return name && name.trim() !== "";
            })
            .map((f, idx) => {
              const active = f.id === currentFloorId;
              return (
                <button
                  key={f.id || idx}
                  className="exhibition-btn"
                  style={{
                    background: active ? "var(--exhibition-accent)" : "#f3f4f6",
                    color:"#111827",
                  }}
                  onClick={() => onFloorChange(f.id)}
                >
                  <div
                    className="exhibition-stack"
                    style={{ alignItems: "center" }}
                  >
                    <div
                      className="exhibition-title"
                      style={{ fontSize: 20, margin: 0 }}
                    >
                      {f.floor_name || f.floor}
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <div style={{ fontSize: 12 }}>
                        {toPersianDigits(
                          f.stores_count ?? f.stores?.length ?? 0
                        )}{" "}
                        غرفه
                      </div>
                      <div style={{ fontSize: 12 }}>
                        طبقه {toPersianDigits(f.floor_number ?? 0)}
                      </div>
                    </div>
                  </div>
                </button>
              );
            })}

          {/* Only show زوفا button if it doesn't exist in the floors data */}
          {!floors.some((f) => {
            const name = f.floor_name || f.floor;
            return name && name.trim() === "زوفا";
          }) && (
            <button
              className="exhibition-btn"
              style={{
                background: showMeetingCards
                  ? "var(--exhibition-accent)"
                  : "#f3f4f6",
                color: "#111827",
              }}
              onClick={onMeetingCardsClick}
            >
              <div
                className="exhibition-stack"
                style={{ alignItems: "center" }}
              >
                <div
                  className="exhibition-title"
                  style={{ fontSize: 20, margin: 0 }}
                >
                  زوفا
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ fontSize: 12 }}>
                    {toPersianDigits(meetingCards?.length || 0)} نشست
                  </div>
                </div>
              </div>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
